module.exports = __webpack_public_path__ + "static/media/phone-12.f2fdf573.png";